import script from "./MenuSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuSection.vue?vue&type=script&setup=true&lang=ts"

import "./MenuSection.vue?vue&type=style&index=0&id=d7a2106a&lang=css"

const __exports__ = script;

export default __exports__